// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PictureModal_modal__4M\\+Ya{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color:rgba(0, 0, 0, 0.5);
    z-index: 400;
}
.PictureModal_container__cii63{
    position: relative;
    max-height: 600px;
    width: 85%;
    max-width: 400px;
    padding: 20px;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.PictureModal_header__ORqJu{
    margin-bottom: 8px;
    color: #1F363D;
    font-size: 31px;
    font-family: 'Gotham Bold', serif;
}
.PictureModal_close__HaV7x{
    position: absolute;
    top: 28px;
    right: 22px;
    height: 12px;
    width: 12px;
    cursor: pointer;
}
.PictureModal_cropperContainer__dVDoW{
    position: relative;
    height: 400px;
    width: 400px;
    margin-top: 30px;
    margin-bottom: 10px;
}
@media(max-width: 500px){
    .PictureModal_cropperContainer__dVDoW{
        height: auto;
        width: 100%;
        aspect-ratio: 1 / 1;
    }
}
.PictureModal_cropperContainer__dVDoW .reactEasyCrop_Container{
    border-radius: 28px;
}
.PictureModal_slider__J8xC7{
    width: 100%;
    margin-top: 30px;
}
.PictureModal_sliderTrack__kmeoL{
    top: 0;
    bottom: 0;
    height: 8px;
    background-color: #40798C;
    border-radius: 999px;
}
.PictureModal_sliderThumbContainer__MLS39:focus-visible{
    outline: none !important;
}
.PictureModal_sliderThumb__wVtef{
    position: relative;
    top: -12.5px;
    height: 16px;
    width: 16px;
    background-color: #FFFFFF;
    border: 1px solid #40798C66;
    border-radius: 50%;
    cursor: pointer;
}
.PictureModal_buttons__5fgEQ{
    display: flex;
    margin-top: 35px;
}
.PictureModal_button__OC1iU{
    width: 194px;
    padding-left: 50px;
    padding-right: 50px;
}
@media(max-width: 500px){
    .PictureModal_button__OC1iU{
        width: calc(50% - 6px);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/PictureModal.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,mCAAmC;IACnC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI;QACI,YAAY;QACZ,WAAW;QACX,mBAAmB;IACvB;AACJ;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,MAAM;IACN,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".modal{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background-color:rgba(0, 0, 0, 0.5);\n    z-index: 400;\n}\n.container{\n    position: relative;\n    max-height: 600px;\n    width: 85%;\n    max-width: 400px;\n    padding: 20px;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.header{\n    margin-bottom: 8px;\n    color: #1F363D;\n    font-size: 31px;\n    font-family: 'Gotham Bold', serif;\n}\n.close{\n    position: absolute;\n    top: 28px;\n    right: 22px;\n    height: 12px;\n    width: 12px;\n    cursor: pointer;\n}\n.cropperContainer{\n    position: relative;\n    height: 400px;\n    width: 400px;\n    margin-top: 30px;\n    margin-bottom: 10px;\n}\n@media(max-width: 500px){\n    .cropperContainer{\n        height: auto;\n        width: 100%;\n        aspect-ratio: 1 / 1;\n    }\n}\n.cropperContainer :global(.reactEasyCrop_Container){\n    border-radius: 28px;\n}\n.slider{\n    width: 100%;\n    margin-top: 30px;\n}\n.sliderTrack{\n    top: 0;\n    bottom: 0;\n    height: 8px;\n    background-color: #40798C;\n    border-radius: 999px;\n}\n.sliderThumbContainer:focus-visible{\n    outline: none !important;\n}\n.sliderThumb{\n    position: relative;\n    top: -12.5px;\n    height: 16px;\n    width: 16px;\n    background-color: #FFFFFF;\n    border: 1px solid #40798C66;\n    border-radius: 50%;\n    cursor: pointer;\n}\n.buttons{\n    display: flex;\n    margin-top: 35px;\n}\n.button{\n    width: 194px;\n    padding-left: 50px;\n    padding-right: 50px;\n}\n@media(max-width: 500px){\n    .button{\n        width: calc(50% - 6px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `PictureModal_modal__4M+Ya`,
	"container": `PictureModal_container__cii63`,
	"header": `PictureModal_header__ORqJu`,
	"close": `PictureModal_close__HaV7x`,
	"cropperContainer": `PictureModal_cropperContainer__dVDoW`,
	"slider": `PictureModal_slider__J8xC7`,
	"sliderTrack": `PictureModal_sliderTrack__kmeoL`,
	"sliderThumbContainer": `PictureModal_sliderThumbContainer__MLS39`,
	"sliderThumb": `PictureModal_sliderThumb__wVtef`,
	"buttons": `PictureModal_buttons__5fgEQ`,
	"button": `PictureModal_button__OC1iU`
};
export default ___CSS_LOADER_EXPORT___;
